// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"46a0e9a5","426":"6c605663","552":"7804af70","674":"ced63004","787":"ff477132","808":"c72b9ffd","832":"5672f6fc"}[chunkId] + ".chunk.js";
};